import httpClient from './_httpClient';

const END_POINT = '/timesheets';

const getTimesheets =
  (
    loggedAs = null,
    status = null,
    fromDate = null,
    toDate = null
  ) => httpClient.get(
    END_POINT,
    {
      params: {
        loggedAs : loggedAs,
        status: status,
        fromDate: fromDate,
        toDate: toDate,
      }
    }
    );
const getTimesheet = (timesheetId, navScopeId) => httpClient.get(END_POINT + '/' + timesheetId + "-" + navScopeId);
const getTimesheetsConfig = () => httpClient.get(END_POINT + '/timesheets_config');
const getTimesheetsConfigOfScope = (scopeId) => httpClient.get(END_POINT + `/timesheets_config/${scopeId}`);
const updateTimesheetsConfig = (scopeId, timesheetConfig) => httpClient.put(END_POINT + `/timesheets_config/${scopeId}`, timesheetConfig);
const saveWorkerContratTimesheets= (timesheets) => httpClient.post('/worker_contrat_timesheets', timesheets);
const submitWorkerContratTimesheets= (timesheets) => httpClient.post('/submit_worker_contrat_timesheet', timesheets);
const approveTimesheet= (timesheets) => httpClient.put('/approve_timesheets', timesheets);
const rejectTimesheet= (timesheets) => httpClient.put('/reject_timesheets', timesheets);
const batchApproveTimesheet= (timesheets) => httpClient.post('/batch_approve_timesheets', timesheets);
const approveTimesheetMail= (token) => httpClient.put('/approve_timesheet_mail/' + token);
const approveAllTimesheetMail= (token) => httpClient.post('/batch_approve_timesheets_mail/' + token);
export {
  getTimesheets,
  getTimesheet,
  getTimesheetsConfig,
  saveWorkerContratTimesheets,
  submitWorkerContratTimesheets,
  approveTimesheet,
  rejectTimesheet,
  batchApproveTimesheet,
  approveTimesheetMail,
  approveAllTimesheetMail,
  getTimesheetsConfigOfScope,
  updateTimesheetsConfig
}
